import Image, { type ImageProps } from "next/image";

import { cn } from "@/lib/utils";

type DiscordMarkProps = Omit<ImageProps, "src" | "width" | "height" | "alt"> & {
  alt?: string;
};

export function DiscordMark({
  alt = "",
  className,
  ...props
}: DiscordMarkProps) {
  return (
    <Image
      src="/images/sportsbooks/discord.webp"
      alt={alt}
      width={32}
      height={24}
      className={cn("size-4 shrink-0 object-contain", className)}
      {...props}
    />
  );
}
